import { $taskCategoryGroups } from './states';
import { fetchTaskCategoryGroups } from './effects';

// Fetch task category groups
$taskCategoryGroups.on(fetchTaskCategoryGroups.doneData, (_, data) => data);